import { arePropsMissing } from '../../../utils/helpers';
import BookingLayout from './BookingLayout';
import BookingOverview from '../../../components/bookingForm/components/BookingOverview';
import Meta from '../../../utils/meta/Meta';

import './booking.css';

interface BookingCheckProps {
  duration_of_stay: number | undefined;
  number_of_adults: number | undefined;
  number_of_children: number | undefined;
  number_of_infants: number | undefined;
  number_of_pets: number | undefined;
  renter:
    | {
        name: string;
        street: string;
        invoice_postal_code: string;
        invoice_city: string;
        invoice_phone?: string;
        invoice_mobile_phone: string;
        email: string;
      }
    | undefined;
  meta: {
    page_title: string | undefined;
  };
}

/* eslint-disable react/destructuring-assignment */

export default function BookingCheck(props: BookingCheckProps): JSX.Element | null {
  if (
    arePropsMissing([
      props.duration_of_stay,
      props.number_of_adults,
      props.number_of_children,
      props.number_of_infants,
      props.number_of_pets,
      props.meta,
    ])
  ) {
    return null;
  }
  return (
    <BookingLayout {...props}>
      <Meta title={props.meta.page_title} />
      <BookingOverview {...props} />
    </BookingLayout>
  );
}
